import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './app';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

import './index.css';
import './array-utils';
// import MemoryLeakChecker from '@components/memory-check';
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    {/* <MemoryLeakChecker> */}
    <App />
    {/* </MemoryLeakChecker> */}
  </React.StrictMode>
);

serviceWorkerRegistration.register();
reportWebVitals();
